import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const mainCategories = categories.filter(c => c.slug !== 'all').slice(0, 6);

  return (
    <footer className="bg-secondary-500">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/20">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">韩漫之家</span>
            </div>
            <p className="text-background-50/70 text-sm leading-relaxed">
              韩漫之家是您最佳的免费韩漫在线观看平台，提供海量下拉式韩漫大全，让您随时随地畅读各种韩国漫画作品，享受流畅的浏览体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {mainCategories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer"
                  >
                    {cat.name}韩漫
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  全部漫画
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-50/70 hover:text-background-50 text-sm transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-background-50/70 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-background-50/60 text-sm"></i>
                </div>
                contact@manhuazhijia.com
              </li>
              <li className="flex items-start gap-2 text-background-50/70 text-sm">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-customer-service-line text-background-50/60 text-sm"></i>
                </div>
                在线客服：工作日 9:00-18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-50/50 text-xs">
            &copy; 2026 韩漫之家 manhuazhijia.com - 免费韩漫在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line text-base"></i>
              </div>
            </a>
            <a href="#" className="text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line text-base"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}